import { cn } from "@tellescope/utils";
import { ReactNode } from "react";

export interface TextCellProps {
  children: ReactNode;
  className?: string;
}

export const TextCell = ({ children, className }: TextCellProps) => {
  return (
    <div className={cn("font-normal text-sm truncate", className)} data-testid="text-cell">
      {children}
    </div>
  );
};
